export default {
  tab: 'Feedback',
  toolbar: {
    markup: 'Markieren',
    record: 'Aufnehmen',
    hint: 'Klicken zum Kommentieren, ziehen zum Zeichnen',
    hintTouch: 'Ziehen, um das Problem zu markieren',
    hintRecord: 'Bildschirm wird aufgenommen',
    exit: 'Beenden',
  },
  popup: {
    about: 'Info',
    placeholder: 'Beschreiben Sie das Problem oder Ihren Vorschlag...',
    submit: 'Absenden',
    sending: 'Wird gesendet...',
    cancel: 'Abbrechen',
    close: 'Schließen',
    my_feedback: 'Mein Feedback',
    screenshot_label: 'Screenshot anhängen',
    screenshot_hint: 'Passwörter und andere sensible Felder werden automatisch abgedeckt.',
    screenshot_short: 'Screenshot',
    screenshot_locked_hint: 'Deine Zeichnung wird in den Screenshot eingebrannt, daher wird er immer angehängt. Sensible Felder werden automatisch abgedeckt.',
    recording_label: 'Aufzeichnung',
    recording_locked_hint: 'Eine Wiedergabe dessen, was die Seite zeigte und wie sie bedient wurde — immer angehängt. Keine Kamera, kein Mikrofon. Sensible Felder werden automatisch abgedeckt.',
    quickOptions: [
      { emoji: '🐛', label: 'Fehler', value: 'Etwas funktioniert nicht' },
      { emoji: '💡', label: 'Vorschlag', value: 'Ich habe einen Vorschlag' },
      { emoji: '🤔', label: 'Unklar', value: 'Ich bin verwirrt' },
    ],
  },
  success: {
    title: 'Danke, Ihr Feedback ist angekommen.',
    title_no_ai: 'Vielen Dank! Wir haben Ihr Feedback erhalten.',
    close: 'Schließen',
    email_saved: 'Sie erhalten eine E-Mail, sobald es gelöst ist.',
    email_error: 'E-Mail konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    track_feedback: 'Feedback verfolgen',
    email_cta: 'E-Mail, sobald es behoben ist',
    notify: 'Melden',
  },
  error: {
    submit: 'Senden fehlgeschlagen. Bitte versuchen Sie es erneut.',
    finalize_title: 'Wir konnten dies noch nicht senden.',
    finalize_message: 'Ihr Feedback ist weiterhin gespeichert. Bitte versuchen Sie es erneut.',
  },
  pet: {
    bubble: 'Brauchen Sie Hilfe?',
  },
  frustration: {
    prompt: 'Etwas funktioniert nicht? Sagen Sie es uns.',
    action: 'Kommentieren',
    dismiss: 'Schließen',
  },
  annotation: {
    drawing: 'Zeichnung',
    element: 'Element',
  },
  draw: {
    note_placeholder: 'Fügen Sie Ihrer Zeichnung eine Notiz hinzu',
    undo: 'Rückgängig',
    redo: 'Wiederholen',
    cancel: 'Abbrechen',
    submit: 'Absenden',
  },
  record: {
    stop: 'Stopp',
    timer_label: 'Aufnahme',
    max_reached: 'Maximale Aufnahmedauer erreicht',
    replay_label: 'screen-recording.json',
    play: 'Aufnahme abspielen',
    close: 'Schließen',
    preview_unavailable: 'Vorschau nicht verfügbar',
  },
  clarify: {
    title: 'Make This Better AI',
    subtitle: 'Wir schärfen dein Feedback',
    thinking: 'Einen Moment...',
    placeholder: 'Details ergänzen, dann absenden',
    send: 'Senden',
    submit: 'Absenden',
    send_feedback: 'Feedback senden',
    skip: 'Überspringen & senden',
    skip_short: 'Überspringen',
    cancel: 'Abbrechen — nicht senden',
    retry: 'Erneut versuchen',
    error: 'Die Frage konnte nicht geladen werden. Senden Sie Ihr Feedback einfach so.',
    expired: 'Diese Feedback-Sitzung ist abgelaufen, bevor sie gesendet werden konnte. Bitte schließe das Widget und sende erneut.',
  },
}
